module.exports = __webpack_public_path__ + "assets/img/1.05546c96.jpg";